import React from 'react'
import { useWizardState } from 'components/dashboard/wizard/WizardStateContext'
import { Form, FormRenderProps } from 'react-final-form'
import { useConditionsSources } from 'hooks/useConditionsSources'
import EntitiesSelect from 'components/ui/form/EntitiesSelect'
import { ConditionFlowContext } from 'components/ui/form/ConditionRulesField/ConditionFlow'
import { useConditionRulesField } from 'components/ui/form/ConditionRulesField/Provider'
import StepLayout from '../StepLayout'

const SelectForm = ({
    form,
    toggleMode,
}: {
    form: FormRenderProps
    toggleMode: () => void
}) => {
    const { invalid, values } = form
    const { actionTitle } = useConditionRulesField()
    const wizard = useWizardState({ context: ConditionFlowContext })
    const {
        zones: { zones, isLoading },
    } = useConditionsSources()

    const handleContinue = () => {
        wizard.submitStep({ ...wizard.context, ...values })
    }

    const handleToggleMode = () => {
        wizard.setContext((prev) => ({ ...prev, ...values }))
        toggleMode()
    }

    return (
        <StepLayout
            conditionType="shippingZones"
            disabled={invalid}
            onContinue={handleContinue}
        >
            <>
                <h3 className="rule-title align-left">
                    {`${actionTitle} when...`}
                </h3>

                <div className="initial-align">
                    <EntitiesSelect
                        blank={false}
                        entities={[
                            {
                                title: 'Shipping Zones Include',
                                value: 'include',
                            },
                            {
                                title: 'Shipping Zones Do Not Include',
                                value: 'exclude',
                            },
                        ]}
                        name="zoneType"
                        defaultValue="include"
                    />
                </div>

                <div className="initial-align">
                    <EntitiesSelect
                        multiSelect
                        searchable
                        entities={zones}
                        disabled={isLoading}
                        name="zoneIds"
                        title="Select Shipping Zones"
                    />
                </div>

                <p onClick={handleToggleMode} className="mb-0 primary-link">
                    I want to create a new Shipping Zone
                </p>
            </>
        </StepLayout>
    )
}

const SelectFormContainer = ({ toggleMode }: { toggleMode: () => void }) => {
    const conditionWizard = useWizardState({ context: ConditionFlowContext })

    return (
        <Form
            onSubmit={() => undefined}
            initialValues={conditionWizard.context}
        >
            {(form) => <SelectForm form={form} toggleMode={toggleMode} />}
        </Form>
    )
}

export default SelectFormContainer
